'use strict';exports.__esModule = true;exports.getLocaleByKey = exports.checkConsistentLanguageMapping = exports.SHORT_LINK_REDIRECT_MAP = exports.LANGUAGE_KEYS_MAP = undefined;var _difference = require('lodash/difference');var _difference2 = _interopRequireDefault(_difference);
var _values = require('lodash/values');var _values2 = _interopRequireDefault(_values);
var _invert = require('lodash/invert');var _invert2 = _interopRequireDefault(_invert);
var _getBaseUrl = require('./utils/get-base-url');var _getBaseUrl2 = _interopRequireDefault(_getBaseUrl);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LANGUAGE_KEYS_MAP = exports.LANGUAGE_KEYS_MAP = {
  en: 'e',
  he: 'h',
  ru: 'r',
  fr: 'f' };


var SHORT_LINK_REDIRECT_MAP = exports.SHORT_LINK_REDIRECT_MAP = {
  home_details: 'a' };


var languageMap = (0, _invert2.default)(LANGUAGE_KEYS_MAP);
var languageKeys = Object.keys(languageMap);
var shortLinkMap = (0, _invert2.default)(SHORT_LINK_REDIRECT_MAP);
var shortLinkRedirectKeys = Object.keys(shortLinkMap);

var checkConsistentLanguageMapping = exports.checkConsistentLanguageMapping = function checkConsistentLanguageMapping(langs, keys) {
  var diffKeys = (0, _difference2.default)(
  langs || _constants.language.supportedLanguages,
  keys || Object.keys(LANGUAGE_KEYS_MAP));


  if (diffKeys.length) {
    throw new Error('Update the language map key in short-link-handler, missing [' + diffKeys.join(', ') + ']');
  }
};

var getLocaleByKey = exports.getLocaleByKey = function getLocaleByKey(key) {var forRoute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (languageKeys.indexOf(key[0]) !== -1) {
    var locale = languageMap[key[0]];

    locale = locale === _constants.language.default ? '' : locale;
    locale = locale && forRoute ? locale + '/' : locale;

    return {
      locale: locale,
      key: key.substr(1) };

  }
  return {
    locale: '',
    key: key };

};

var transformParts = function transformParts(parts) {
  if (parts.length === 3) {var
    locale = parts[0],prefix = parts[1],id = parts[2];
    if (Object.keys(LANGUAGE_KEYS_MAP).includes(locale) && shortLinkRedirectKeys.includes(prefix)) {
      return ['' + locale[0] + prefix, id];
    }
  }
  return parts;
};

var shortLinkHandler = function shortLinkHandler(request, response, next) {
  var parts = request.url.split('/').filter(function (p) {return p;});
  parts = transformParts(parts);

  if (parts.length === 2 && parts[0].length <= 2) {
    var id = parts[1];var _getLocaleByKey =
    getLocaleByKey(parts[0], true),key = _getLocaleByKey.key,locale = _getLocaleByKey.locale;

    if (shortLinkRedirectKeys.indexOf(key) !== -1) {
      var urlBase = (0, _getBaseUrl2.default)(request, { returnLocalhost: true });
      var fullUrl = urlBase + '/' + locale + shortLinkMap[key] + '/' + id;

      return response.redirect(301, fullUrl);
    }
  }

  return next();
};

checkConsistentLanguageMapping();exports.default =

shortLinkHandler;


//////////////////
// WEBPACK FOOTER
// ./src/middleware/short-link-handler.js
// module id = 3048
// module chunks = 0